import styled from 'styled-components';

import { DevelopmentPlanUserFragment } from '@treams/treams-network';
import { Avatar, Paragraph, Skeleton, Subheading } from '@treams/treams-ui';

import { useJobTitleName } from '../../job/useJobTitleName';

const StyledUserCard = styled.div`
	display: flex;
	flex-direction: row;
	column-gap: 0.5rem;
	margin-top: 20px;
`;

const UserCardName = styled(Subheading)`
	margin: 0px;
`;

const UserCardJobTitle = styled(Paragraph)`
	margin: 0px 0;
`;

export default Skeleton(
	function UserCard({ user }: { user: DevelopmentPlanUserFragment }) {
		const jobTitleName = useJobTitleName();
		const jobTitle = jobTitleName(user.currentJobPosition?.jobTitle);

		return (
			<StyledUserCard>
				<Avatar user={user} size={40} />
				<div>
					<UserCardName>
						{user.firstName} {user.lastName}
					</UserCardName>
					{jobTitle && <UserCardJobTitle>{jobTitle}</UserCardJobTitle>}
				</div>
			</StyledUserCard>
		);
	},
	function UserCard() {
		return <Skeleton.Box height={40} maxWidth={150} mt={20} />;
	},
);
